import type { HtmlAttributes } from '@studio/design-system/props';
import type { ReactElement } from 'react';
import { useStore } from './store/hooks.js';
import { Meter, Placeholder } from '#~/audio/components/meter/index.js';
import { Columns } from '#~/common/editor/index.js';
import { Viewer } from '#~/video/components/viewer/index.js';
import { BridgeSelector } from './source/bridge-selector.js';

/** `<Preview>` component. */
export const Preview = (props: HtmlAttributes): ReactElement => {
  const { audio, video } = useStore((µ) => µ.previews);

  return (
    <Columns.Column {...props}>
      {!!video && <Viewer className='rounded border border-base-100' deviceId={video.deviceId} />}
      {audio && !audio.error ? <Meter deviceId={audio.deviceId} /> : <Placeholder />}
      {!!audio || !!video ? <BridgeSelector /> : null}
    </Columns.Column>
  );
};
